<!-- eslint-disable vue/no-unused-refs -->
<template>
  <dialogWrap
    v-model="dialogShow"
    title="发起维保"
    width="540px"
    @change="closeDialog"
    ref="dialogWrap"
  >
    <el-form :model="form" ref="form" label-width="120px">
      <el-row>
        <el-col :span="18">
          <el-form-item label="司机警示金">
            <el-radio-group
              v-model="form.isDriverWarning"
              @change="changeDriverWarning"
            >
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.isDriverWarning === '1'">
            <el-form-item v-if="+row.type === 2" label="超保费">
              <el-input
                @input="val => priceChange(val, 'exceedAmount')"
                v-model="form.exceedAmount"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
            <div v-else>
              <el-form-item label="保险上浮费">
                <el-input
                  @input="val => priceChange(val, 'floatAmount')"
                  v-model="form.floatAmount"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
              <el-form-item label="车辆加速折旧费">
                <el-input
                  @input="val => priceChange(val, 'depreciationAmount')"
                  v-model="form.depreciationAmount"
                >
                  <template slot="append"
                    >元</template
                  >
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button size="small" @click="dialogShow = false">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="submit">
        确定
      </el-button>
    </template>
  </dialogWrap>
</template>

<script>
import { limitMoreZero } from '@/utils/validate'
import { initiateMaintenance } from '@/api/domain/carsService'

export default {
  name: 'initiateMaintenance',
  data() {
    return {
      dialogShow: false,
      row: null,
      form: {
        isDriverWarning: '0', // 0:否；1:是,
        exceedAmount: '', // 超保费
        floatAmount: '', // 保险上浮费
        depreciationAmount: '', // 车辆加速折旧费
      },
    }
  },
  methods: {
    initForm() {
      this.form = {
        isDriverWarning: '0',
        exceedAmount: '', // 超保费
        floatAmount: '', // 保险上浮费
        depreciationAmount: '', // 车辆加速折旧费
      }
    },
    // 关闭弹框
    closeDialog(val) {
      if (!val) this.initForm()
    },
    // 切换司机警示金
    changeDriverWarning() {
      ['exceedAmount', 'floatAmount', 'depreciationAmount'].forEach((item) => {
        this.form[item] = ''
      })
    },
    // 监听金额变化
    priceChange(val, key) {
      limitMoreZero(
        val,
        (value) => {
          this.$set(this.form, key, value)
        },
        9,
      )
    },

    // 保存发起维保内容
    async submit() {
      const params = this.form
      delete params.isDriverWarning
      params.id = this.row.id
      Object.keys(params).forEach((key) => {
        if (!params[key]) params[key] = '0.00'
      })
      const { code } = await initiateMaintenance(params)
      if (code === 1) {
        this.dialogShow = false
        this.$emit('getList')
      }
    },
  },
}
</script>

<style></style>
